import { Component, NgZone, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { PatientService } from 'src/app/services/patient.service';
import { ProblemService } from 'src/app/services/problem.service';

declare var Ext: any;

@ManageType('ProblemWidgetComponent')
@Component({
  selector: 'app-problem-widget',
  templateUrl: './problem-widget.component.html',
  styleUrls: ['./problem-widget.component.scss']
})
export class ProblemWidgetComponent implements OnInit {

  constructor(private patient: PatientService, private ngZone: NgZone,
              public problemservice: ProblemService) { }

  ngOnInit(): void {
  }

  newProblem(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const patient = new Ext.CNPatient(this.patient.patient.id);
        patient.on('itemLoaded', (item) => {
          const problemwindow = new Ext.CNProblemWindow({ patient: item });
          problemwindow.show();
          problemwindow.on('problemCreated', () => {
            setTimeout(() => {
              this.reload();
            });
          });
        });
      });
    });
  }

  reload() {
    this.ngZone.run(() => {
      this.problemservice.reloadAllSubjects();
    });
  }

}
